module.exports = __webpack_public_path__ + "assets/d02f64dc92eb8807707bc792f0c7c916.svg";